import React from 'react';
import block from 'bem-cn';
import PT from 'prop-types';
import { useSelector } from 'react-redux';

import CheckBox from 'components/CheckBox';
import Button from 'components/Button';
import InputDate from 'components/InputDate';

import './PaymentHistoryFilter.scss';

const b = block('payment-history-filter');

const PaymentHistoryFilter = ({
  onIsSuccessChange,
  onIsTimeIsUpChange,
  onDateFromChange,
  onDateToChange,
  onSubmit,
  values,
}) => {
  const { locale } = useSelector(state => state.locale);

  const {
    isSuccess,
    isTimeIsUp,
    dateFrom,
    dateTo,
  } = values;

  return (
    <form className={b()} onSubmit={onSubmit}>
      <div className={b('checkboxes')}>
        <p className={b('label')}>{locale.status}</p>
        <div className={b('checkboxes-wrapper')}>
          <label className={b('checkbox')} onClick={onIsSuccessChange}>
            <div className={b('checkbox-input')}>
              <CheckBox
                name="isSuccess"
                checked={isSuccess}
                onChange={onIsSuccessChange}
              />
            </div>
            <p className={b('checkbox-text')} >
              {locale.success}
            </p>
          </label>

          <label className={b('checkbox')} onClick={onIsTimeIsUpChange}>
            <div className={b('checkbox-input')}>
              <CheckBox
                name="isTimeIsUp"
                checked={isTimeIsUp}
                onChange={onIsTimeIsUpChange}
              />
            </div>
            <p className={b('checkbox-text')}>
              {locale.timeIsUp}
            </p>
          </label>
        </div>
      </div>

      <label className={b('field')}>
        <p className={b('label')}>
          {locale.from}
        </p>
        <div className={b('input')}>
          <InputDate
            value={dateFrom}
            onChange={onDateFromChange}
            dateFormat="DD.MM.YYYY HH:mm"
            showTimeSelect
          />
        </div>
      </label>

      <label className={b('field')}>
        <p className={b('label')}>
          {locale.to}
        </p>
        <div className={b('input')}>
          <InputDate
            value={dateTo}
            onChange={onDateToChange}
            dateFormat="DD.MM.YYYY HH:mm"
            showTimeSelect
          />
        </div>
      </label>

      <div className={b('button')}>
        <Button type="submit" text={locale.show} />
      </div>
    </form>
  );
};

PaymentHistoryFilter.propTypes = {};

export default PaymentHistoryFilter;
